'use client'

import {ReactNode, useState} from 'react'
import s from './index.module.scss'
import dynamic from 'next/dynamic'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {triggerShareAnalytics} from '@app/[lang]/(common-header-footer)/game/[gameName]/[gameCode]/share-handler'
const SharePopup = dynamic(() => import('./share-popup/index'))

type Props = {
  url: string
  ShareIcon: ReactNode
  gameNameEn: string
  gameCode: string
}

export default function ShareActions({url, ShareIcon, gameNameEn, gameCode}: Props) {
  const shareData = {
    url,
  }

  const [isShareMenuOpen, setIsShareMenuOpen] = useState(false)

  const triggerShareMenu = () => {
    let isNativeShare = true
    if (window.navigator.share) {
      window.navigator.share(shareData)
    } else {
      isNativeShare = false
      setIsShareMenuOpen(true)
    }
    triggerShareAnalytics({
      gameCode,
      gameNameEn,
      shareSource: 'portal',
      isNativeShare,
    })
  }

  return (
    <div className={s.buttonBox}>
      <SharePopup shareData={shareData} isOpen={isShareMenuOpen} setIsOpen={setIsShareMenuOpen} />
      <button onClick={triggerShareMenu} className={s.share_button}>
        {ShareIcon}
      </button>
    </div>
  )
}
